import React from 'react'
import * as Types from 'types'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { compose } from 'recompose'
import {
  withJsonApiProps,
  withLayout,
  goToNextStep,
  useFlashMessages,
  useOrderedSteps,
  groupFilesByPersonalVerificationCategory,
} from 'utils'
import { ApplicationLayout } from 'components'
import { PersonalVerificationForm } from 'forms'
import { STEP, SAVE_ERROR_MESSAGE } from 'config'
import { isEmpty, reduce } from 'lodash'
import { uploadFiles } from 'api'

const propTypes = {
  tenantCaseFiles: PropTypes.arrayOf(Types.file).isRequired,
  certType: PropTypes.string,
  fundingProgram: PropTypes.string,
}
const defaultProps = {}

function PersonalVerification({ tenantCaseFiles, certType, fundingProgram }) {
  const { showFlashFailure } = useFlashMessages()
  const [steps] = useOrderedSteps()
  const personalVerificationFiles =
    groupFilesByPersonalVerificationCategory(tenantCaseFiles)

  const categorizeNewFiles = (newFiles) => {
    return reduce(
      newFiles,
      (results, files, category) => {
        const newFiles = files.filter((file) => !file.contentDocumentId)
        if (isEmpty(newFiles)) return results

        return {
          ...results,
          [category]: newFiles,
        }
      },
      {}
    )
  }

  return (
    <>
      <Helmet>
        <title>Personal Verification</title>
      </Helmet>
      <div className="page-header">
        <h1>Personal Verification</h1>
      </div>
      <PersonalVerificationForm
        initialValues={{ personalVerificationFiles }}
        certType={certType}
        fundingProgram={fundingProgram}
        onSubmit={async ({ personalVerificationFiles }) => {
          const categorizedNewFiles = categorizeNewFiles(
            personalVerificationFiles
          )

          if (!isEmpty(categorizedNewFiles)) {
            try {
              for (const category in categorizedNewFiles) {
                const files = categorizedNewFiles[category]
                await uploadFiles({ files, prefix: category })
              }
            } catch {
              return showFlashFailure(SAVE_ERROR_MESSAGE)
            }
          }
          const personalVerificationIndex = steps.findIndex(
            (s) => s?.name === STEP.PERSONAL_VERIFICATION.name
          )
          const nextStep = steps[personalVerificationIndex + 1]
          if (nextStep) goToNextStep(nextStep)
        }}
      />
    </>
  )
}

PersonalVerification.propTypes = propTypes
PersonalVerification.defaultProps = defaultProps

export default compose(
  withJsonApiProps(),
  withLayout(ApplicationLayout)
)(PersonalVerification)
